
import App from './App'
import router from './router';
import store from './store';
// import './mock'
import dfilters from './utils/dfilters';
import 'babel-polyfill'; // 兼容ie
import {isNewVersion} from '@/utils/public';
for (let key in dfilters) {
  Vue.filter(key, dfilters[key]);
}// 视频组件
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import VideoPlayer from 'vue-video-player' // 视频组件
Vue.use(VideoPlayer)
Vue.config.productionTip = false;
//禁止MessageBox/Dialog 点击遮罩关闭
// ELEMENT.MessageBox.setDefaults({
//   closeOnClickModal: false
// })
// ELEMENT.Dialog.props.closeOnClickModal.default = false;

router.beforeEach((to, from, next) => {
  isNewVersion()
  //在跳转前进行一些操作，通过matched是因为层次路由 
  if (to.name === 'home') {
    document.title = store.state.platformInfo.title;
  } else {
    document.title = to.matched[0].meta.title; //路由跳转 
  }
  window, scrollTo(0, 0); //切换页面回的最顶部
  next()
});


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js